import React, { useState, useEffect } from 'react';

const collarSizes = [
  '13', '13.5', '14', '14.5', '15', '15.5', '16', '16.5',
  '17', '17.5', '18', '18.5', '19', '19.5', '20', '20.5'
];

const StepCollarSize = ({ data, setData, onNext, onPrev }) => {
  const [customSize, setCustomSize] = useState('');

  const handleSelect = (size) => {
    setData(prev => ({
      ...prev,
      collarSize: size
    }));
    setCustomSize('');
  };

  const handleCustomChange = () => {
    if (customSize) {
      setData(prev => ({
        ...prev,
        collarSize: customSize
      }));
    }
  };

  const handleSkip = () => {
    setData(prev => ({
      ...prev,
      collarSize: null
    }));
    onNext();
  };

  // ✅ Preload custom value if not in preset
  useEffect(() => {
    const isCustom = data.collarSize && !collarSizes.includes(data.collarSize);
    if (isCustom) setCustomSize(data.collarSize);
  }, [data.collarSize]);

  return (
    <main className="rbt-main-wrapper">
      <div className="container custom-checkout-container">
        <div className="row">
          <div className="">
            <div className="collar-selection-container">
              <h3 className="collar-selection-title">What is your collar size?</h3>

              <div className="collar-selection-grid selection-grid">
                {collarSizes.map(size => (
                  <button
                    key={size}
                    className={`selection-btn ${data.collarSize === size ? 'active' : ''}`}
                    onClick={() => handleSelect(size)}
                  >
                    {size}
                  </button>
                ))}
              </div>

              <div className="custom-height mt-3">
                <label>Something else:</label>
                <div style={{ display: 'flex', gap: '10px', marginTop: '5px' }}>
                  <input
                    type="text"
                    placeholder="in"
                    value={customSize}
                    onChange={(e) => setCustomSize(e.target.value)}
                    onBlur={handleCustomChange}
                  />
                </div>
              </div>

              <button className="skip-btn mt-3" onClick={handleSkip}>
                I'm not sure, skip this question
              </button>

              <div className="nav-buttons mt-4">
                <button className="selection-prev-btn" onClick={onPrev}>
                  Prev
                </button>
                <button
                  className="selection-next-btn"
                  onClick={onNext}
                  disabled={!data.collarSize}
                >
                  Next
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default StepCollarSize;
